<template>
  <div class="block">
    <el-descriptions class="margin-top" :title="$t('whitelist.orgInfoTitle')" :column="4" size="medium" border>
      <el-descriptions-item contentClassName="sky-hc-od__desc-con">
        <template slot="label">
          {{ $t('whitelist.orgInfo.orgNameTitle') }}
        </template>
        {{ orgInfo.orgName }}
      </el-descriptions-item>
      <el-descriptions-item contentClassName="sky-hc-od__desc-con-2">
        <template slot="label">
          {{ $t('whitelist.orgInfo.orgTypeTitle') }}
        </template>
        {{ orgInfo.orgType ? $t('whitelist.orgTypeName.' + orgInfo.orgType) : '--' }}
      </el-descriptions-item>
      <el-descriptions-item contentClassName="sky-hc-od__desc-con-2">
        <template slot="label">
          {{ $t('whitelist.orgInfo.orgIdTitle') }}
        </template>
        {{ orgInfo.orgId }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location"></i>
          {{ $t('whitelist.orgInfo.areaTitle') }}
        </template>
        {{ orgInfo.area }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          {{ $t('activeOrg.industry') }}
        </template>
        {{ orgInfo.tradeName ? orgInfo.tradeName : '--' }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          {{ $t('activeOrg.termianlSum') }}
        </template>
        <el-tooltip
          :disabled="!(orgInfo.terminalCount && orgInfo.terminalCount > 0)"
          content="点击查看终端详情"
          placement="top-start"
        >
          <span
            :class="{ 'sky-hc-od__link': orgInfo.terminalCount && orgInfo.terminalCount > 0 }"
            @click="handleShowTerminal"
          >
            {{ orgInfo.terminalCount ? orgInfo.terminalCount : '--' }}
          </span>
        </el-tooltip>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          {{ $t('activeOrg.subOrgSum') }}
        </template>
        {{ orgInfo.subOrgCount ? orgInfo.subOrgCount : '--' }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          {{ $t('whitelist.orgInfo.createTime') }}
        </template>
        {{ orgInfo.orgCreateTime | formatTime('yyyy-MM-dd HH:mm:ss') }}
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="{ minWidth: '140px' }">
        <template slot="label">
          <i class="el-icon-s-custom"></i>
          {{ $t('whitelist.orgInfo.orgAdminUsernameTitle') }}({{
            orgInfo.maintainPersonInfo ? orgInfo.maintainPersonInfo.length : '0'
          }}人)
        </template>
        <div>
          <div class="sky-hc-od__admin-list">
            <!-- <span class="sky-hc-od__admin-item sky-hc-od__admin-crown"
              >【{{ orgInfo.orgAdmin }}:{{
                orgInfo.orgAdminPhoneNumber
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;】</span
            > -->
            <div v-for="(item, index) in orgInfo.maintainPersonInfo" :key="'0' + index" class="sky-hc-od__admin-item">
              【{{ item.maintainPersonName }}:{{ item.phoneNumber
              }}<span :class="{ 'sky-hc-od__admin-crown': orgInfo.orgAdminPhoneNumber === item.phoneNumber }"></span
              >】<i class="sky-hc-od__admin-item--num">登录 {{ item.loginCount ? item.loginCount : '--' }} 次</i>
            </div>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <Terminal :orgName="orgInfo.orgName" :orgId="orgId" ref="terminal" />
  </div>
</template>
<script>
import { Tooltip } from 'element-ui'

import { getOrgInfo } from '@/api/whitelist'
import Terminal from '@/views/activeOrganization/components/terminal'
import descriptions from '@/views/components/descriptions'
import descriptionsItem from '@/views/components/descriptions-item'
export default {
  name: 'orgInfo',
  components: {
    elDescriptions: descriptions,
    elDescriptionsItem: descriptionsItem,
    Terminal,
    [Tooltip.name]: Tooltip
  },
  props: {
    orgId: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      orgInfo: {},
      contentStyle: {
        with: '200px'
      }
    }
  },
  watch: {
    orgId() {
      this.handleGetOrgInfo()
    }
  },
  created() {
    this.handleGetOrgInfo()
  },
  methods: {
    handleGetOrgInfo() {
      getOrgInfo({
        id: this.orgId
      }).then(response => {
        const emptyOrgInfo = {
          orgName: '--',
          orgType: '',
          orgId: '--',
          area: '--',
          orgAdmin: '--',
          orgAdminPhoneNumber: '--',
          orgCreateTime: ''
        }
        const content = response.data.content
        if (content) {
          for (let i in content) {
            if (!content[i] && i !== 'orgType') {
              content[i] = '--'
            }
          }
        }
        this.orgInfo = response.data.content ? Object.assign(emptyOrgInfo, response.data.content) : emptyOrgInfo
        this.$emit('getOrgInfo', this.orgInfo)
      })
    },
    handleShowTerminal() {
      if (this.orgInfo.terminalCount) {
        this.$refs.terminal.showTerminals()
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-od) {
  @include e(admin-crown) {
    width: 18px;
    height: 16px;
    display: inline-block;
    background: url('../../../assets/styles/css_images/huangguan@2x.png') no-repeat center !important;

    background-size: 100% 100% !important;
  }
  @include e(admin-list) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  @include e(desc-con) {
    width: 260px;
  }
  @include e(desc-con-2) {
    width: 100px;
  }
  @include e(link) {
    color: $--color-primary;
    cursor: pointer;
    text-decoration: underline;
  }
  @include e(admin-item) {
    margin-right: 10px;
    @include m(num) {
      font-size: 12px;
      font-style: normal;
      margin-left: -5px;
      color: rgba(0, 0, 0, 0.48);
    }
  }
}
</style>
